import { Fragment, useEffect, useState } from "react";
import { formatNumber, getEventStatus } from "../utils/function";
import { format } from "date-fns";
import { cloneDeep, get } from "lodash";

import InviteCollaborator from "./InviteCollaborator";
import Tooltip from "./common/tooltip/Tooltip";
import ChatBox from "./ChatBox";
import useAppState from "context/useAppState";
import { getFeteFormatByNumber } from "utils/fete";
import AssignTaskModal from "./common/modal/AssignTaskModal";
import FeteDueDateModal from "./FeteDueDateModal";
import FeteAddRemainder from "./FeteAddRemainder";
import allImgPaths from "assets/images";
import Toast from "./common/Toast";
import defaultProfileImage from "../assets/images/default-user.png";
import { getEventImage, getSampleImages } from "services/event";

const eventTypes = [
  'awards', 'expo', 'networking', 'product-launch', 'retreat', 'others',
]

function FeteDescription(props: any) {
  const { eventData: eventDataFromHook, setOpenInviteCollaborators } = props;
  const { setState: setEventDataState, showChatbox, updatedFeteImageUrl, sampleImages } = useAppState("eventData");

  const [eventData, setEventData] = useState(eventDataFromHook);
  const [newImageUrl, setNewImageUrl] = useState(null)
  const [imageLoading, setImageLoading] = useState(false)

  useEffect(() => {
    setEventData(eventDataFromHook)
  }, [eventDataFromHook])

  useEffect(() => {
    if (updatedFeteImageUrl) {
      const clonedEventData = cloneDeep(eventData);
      clonedEventData['image'] = updatedFeteImageUrl;
      setEventData(clonedEventData);
      setEventDataState({ updatedFeteImageUrl: null })
    }
  }, [updatedFeteImageUrl])

  useEffect(() => {
    if (!sampleImages?.length) {
      fetchSampleImages()
    }
  }, [])

  const fetchSampleImages = async () => {
    const path = eventTypes.includes(eventData?.type?.toLowerCase()) ? eventData?.type?.toLowerCase() : 'others'
    const { data } = await getSampleImages({ path })
    
    if (data?.length) {
      setEventDataState({ sampleImages: data })
    }
  }

  const {
    attendees,
    budget,
    members,
    locations,
    name,
    format: eventFormat,
    objective,
    start_date,
    end_date,
    time_zone,
    type,
    image
  } = eventData;


  const feteFormat: any = getFeteFormatByNumber(eventFormat);

  const statusText: any = getEventStatus(start_date, end_date);

  const handleImageError = (e: any) => {
    e.target.src = defaultProfileImage
  }

  const handleEventImage = (e: any) => {
    e.target.src = allImgPaths.dummyImg1
  }

  // const reloadImage = async (eventId: any) => {
  //   try {
  //     setImageLoading(true)
  //     const { data } = await getEventImage(eventId)
  //     setImageLoading(false)
  //     if (data) setNewImageUrl(data);

  //   } catch (error) {
  //     setImageLoading(false)
  //   }
  // }

  const openImageSelector = () => {
    setEventDataState({ showImageUploader: true })
  }

  return (
    <>
      <div className="flex gap-x-6 relative card-anim-fete-description planning-anim-fete-description">
        <div className="mb-4 planning-fete-description">
          <div className="relative w-[334px] h-[282px] rounded-xl planning-fete-img group">
            {
              imageLoading && (
                <div className="absolute top-0 left-0 w-full h-full bg-gray-200 rounded-xl flex items-center justify-center">
                  <div className="image-loader"></div> {/* Add your loader styles here */}
                </div>
              )
            }
            {
              !imageLoading &&
              <img
                className="rounded-xl object-cover w-full h-full"
                src={image || allImgPaths.dummyImg1}
                // src={allImgPaths.dummyImg1}
                alt=""
                onError={handleEventImage}
              />
            }

            {/* Edit Button */}
            <span onClick={openImageSelector} className="hidden group-hover:block absolute bottom-5 right-5 cursor-pointer bg-white border border-[#D0D5DD] rounded-lg px-2 py-2 hover:border-[#1e0af5]">
              <img className="w-[22px] h-[22px]" src={allImgPaths.EditIcon2} alt="edit icon" />
            </span>
          </div>
          <div className="planning-fete-info min-w-[280px] min-h-[280px]">
            <div className="flex gap-x-2 items-center pb-2">
              {/* <span className="cursor-pointer text-lg">
                <img
                  onClick={() => reloadImage(eventData._id)}
                  src={allImgPaths.RefreshIcon}
                  alt=""
                />
              </span> */}
              <span className="text-sm text-[#1E0AF5] font-interSemiBold">{type}</span>
              <span className="text-[#344054] text-xs border border-[#EAECF0] rounded py-0.5 px-2 font-interMedium bg-[#F9FAFB]">
                {feteFormat}
              </span>
            </div>

            <h6 className="font-interMedium text-xl text-[#101828] pb-3">{name}</h6>

            <div className="flex items-center gap-x-2 pb-3 card-anim-organiser">
              <span className="text-[#475467] text-base">Organisers : </span>
              <div className="flex items-center ">
                {members?.length > 0 &&
                  members.slice(0, 3).map((user: any) => (
                    <Fragment key={user?._id}>
                      <div className="w-8 h-8 rounded-full -ml-2 border-2 border-[#fff] first:ml-0 relative group">
                        <img
                          className="w-full h-full rounded-full on-hover-border-shadow"
                          src={user?.profile_image ? user.profile_image : allImgPaths.defaultProfile}
                          alt="profile"
                          onError={handleImageError}
                        />
                        <div className="bg-[#0C111D] rounded-lg py-2 px-3 min-w-[122px] absolute z-10 top-full left-1/2 transform -translate-x-1/2 mt-2 hidden group-hover:block cursor-default">
                          <span className="arrow-top w-0 h-0 block absolute left-1/2 transform -translate-x-1/2 -top-2"></span>
                          <ul className="text-center">
                            <li className="text-xs text-white pb-1 last:pb-0" key={user?._id}>
                              {user?.name}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                {members?.length > 3 && (
                  <div className="w-[30px] h-[30px] rounded-full -ml-3 bg-[#dfe2e5] flex items-center justify-center text-sm relative group cursor-pointer">
                    +{members?.slice(3).length}
                    <Tooltip list={members.slice(3)} />
                  </div>
                )}

                <div className="ml-2" >
                  <img
                    className="w-7 h-7 p-1 rounded-full cursor-pointer !border !border-dashed !border-[#ccc] on-hover-border-shadow"
                    src={allImgPaths.plusIcon5}
                    alt="plus icon"
                    onClick={() => setOpenInviteCollaborators(true)}
                  />
                </div>
              </div>
            </div>

            <div className="card-anim-wrapper">
              <div className="flex items-start gap-x-2 pb-3">
                <img className="w-4 h-4 mt-1.5" src={allImgPaths.targetIcon} alt="target icon" />
                <span className="text-base text-[#344054] font-interMedium">{objective}</span>
              </div>

              <div className="flex items-center gap-x-2 pb-3 flex-wrap gap-y-3">
                <img className="w-4 h-4" src={allImgPaths.calenderIcon} alt="target icon" />

                <span className="text-base text-[#344054] font-interMedium">
                  {get(eventData, "start_date") && get(eventData, "end_date") && (
                    <>
                      {format(new Date(start_date), "dd MMM yyyy")}

                      {format(new Date(start_date), "dd MMM yyyy") ===
                        format(new Date(end_date), "dd MMM yyyy")
                        ? ""
                        : `${" "} to  ${format(new Date(end_date), "dd MMM yyyy")}`}
                    </>
                  )}
                </span>

                <span
                  className={` bg-[#E8E6FE] text-xs border border-[#EAECF0] ${statusText?.includes("Past Event") ? "text-[D92D20]" : "text-[#1E0AF5]"
                    } rounded py-px px-2 font-interMedium text-xs`}
                >
                  {statusText}
                </span>
              </div>

              <div className="flex items-center gap-x-2 pb-3">
                <img className="w-4 h-4" src={allImgPaths.teamIcon2} alt="target icon" />
                <span className="text-base text-[#344054] font-interMedium">
                  {!attendees?.min && !attendees?.max ? '--' : ''}
                  {
                    attendees?.min !== attendees?.max &&
                    <>
                      {attendees?.min ? formatNumber(attendees?.min) : ''}{attendees?.min && attendees?.max ? ' - ' : ''}{attendees?.max ? formatNumber(attendees?.max) : ''}
                    </>
                  }
                  {
                    attendees?.min == attendees?.max &&
                    <>
                      {attendees?.max ? formatNumber(attendees?.max) : ''}
                    </>
                  }
                </span>
              </div>

              <div className="flex items-center gap-x-2 pb-3">
                <img className="w-4 h-4" src={allImgPaths.locationIcon} alt="target icon" />
                {locations?.length > 0 &&
                  locations.map((city: string, index: number) => (
                    <span className="text-base text-[#344054] font-interMedium flex gap-1" key={index}>
                      {city}
                      {index < locations.length - 1 && " ,  "}
                    </span>
                  ))}
                {locations?.length === 0 && (
                  <span className="text-base text-[#344054] font-interMedium">--</span>
                )}
              </div>

              <div className="flex items-center gap-x-2 pb-1">
                <img className="w-4 h-4" src={allImgPaths.dollorIcon} alt="dollor icon" />
                <span className="text-base text-[#344054] font-interMedium">
                  {!budget?.min && !budget?.max ? '--' : ''}
                  {
                    budget?.min !== budget?.max &&
                    <>
                      {budget?.min ? formatNumber(budget?.min) : ''}{budget?.min && budget?.max ? ' - ' : ''}{budget?.max ? formatNumber(budget?.max) : ''}
                    </>
                  }
                  {
                    budget?.min == budget?.max &&
                    <>
                      {budget?.max ? formatNumber(budget?.max) : ''}
                    </>
                  }
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Planning Fete Chatbox */}
        <div className="planning-fete-chatbox rounded-bl-2xl rounded-br-2xl">{showChatbox && <ChatBox />}</div>
      </div>
    </>
  );
}

export default FeteDescription;
